/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.roles.TenantRole
*/
export var TenantRole;
(function (TenantRole) {
    TenantRole["USER"] = "USER";
    TenantRole["CREATOR"] = "CREATOR";
    TenantRole["ADMIN"] = "ADMIN";
    TenantRole["TENANT_ADMIN"] = "TENANT_ADMIN";
})(TenantRole || (TenantRole = {}));
//# sourceMappingURL=TenantRole.js.map